import {
  INCISOR_CANINE_TOOTH_IDS,
  LOWER_INCISOR_CANINE_TOOTH_IDS,
  LOWER_MOLAR_TOOTH_IDS,
  LOWER_PREMOLAR_TOOTH_IDS,
  MOLAR_TOOTH_IDS,
  PREMOLAR_TOOTH_IDS,
} from '@constants/Charting/conditions.schema'

/** Hidden on Add-ons (step 3) until these fields ship again. */
export const SHOW_APPOINTMENT_LAB_ORDERS = false
export const SHOW_APPOINTMENT_TEMPLATE = false

export const AVAILABLE_TIMES = [
  '08:00',
  '08:15',
  '08:30',
  '08:45',
  '09:00',
  '09:15',
  '09:30',
  '09:45',
  '10:00',
  '10:15',
  '10:30',
  '10:45',
  '11:00',
  '11:15',
  '11:30',
  '11:45',
  '12:00',
  '12:15',
  '12:30',
  '12:45',
  '13:00',
  '13:15',
  '13:30',
  '13:45',
  '14:00',
  '14:15',
  '14:30',
  '14:45',
  '15:00',
  '15:15',
  '15:30',
  '15:45',
  '16:00',
  '16:15',
  '16:30',
  '16:45',
  '17:00',
]

export const APPT_OPTION_LIST = [
  {
    procedure_id: '38fda6bf-9950-4d98-9987-26ef525f28b1',
    procedure_code: 'PROC004',
  },
  {
    procedure_id: '1a050885-a033-400a-991e-55993740d992',
    procedure_code: 'PROC005',
  },
  {
    procedure_id: '05f7a873-9629-4f47-89bc-631f6f72326d',
    procedure_code: 'PROC024',
  },
  {
    procedure_id: '0d78508e-2c95-466f-bff8-4be9e9136d83',
    procedure_code: 'PROC006',
  },
  {
    procedure_id: '653245df-026a-4ade-8249-93029492dc52',
    procedure_code: 'PROC027',
  },
]

export const VISIT_EVERY = [
  { value: 0, label: 'Week' },
  { value: 1, label: 'Month' },
]

export const END_EVERY = [
  { value: 'NEVER', label: 'Never' },
  { value: 'COUNT', label: 'Count' },
  { value: 'UNTIL', label: 'Until' },
]
export const DURATION = [
  { value: '15', label: '15 minutes' },
  { value: '30', label: '30 minutes' },
  { value: '60', label: '60 minutes' },
]

export const TEMPLATE_LIST = [
  {
    template_id: '5ff41c22-30bc-4a28-a833-32f12bbd0ac4',
    template_name: 'homepage_template',
    description: 'This is a template description',
  },
  {
    template_id: '52884d1b-1314-4baa-8d33-c210d6c44af9',
    template_name: 'product_template',
    description: 'Sample template description',
  },
  {
    template_id: '117b807b-8631-4eea-9321-de9dedee2283',
    template_name: 'contact_template',
    description: 'Lorem ipsum dolor sit amet',
  },
  {
    template_id: '008e4a9d-51d1-4b71-97c7-fcb355643a70',
    template_name: 'about_template',
    description: 'This is a template description',
  },
  {
    template_id: '8ea19022-cf1d-44ea-9396-07cf948ba9e8',
    template_name: 'blog_template',
    description: 'Sample template description',
  },
]

export const ENHANCE_OPTIONS = [
  {
    value: '0',
    label: 'Formalize',
    icon: '',
  },
  {
    value: '1',
    label: 'Summarize',
    icon: '',
  },
  {
    value: '2',
    label: 'Simplify',
    icon: '',
  },
  {
    value: '3',
    label: 'Correct',
    icon: 'mgc_check_line',
  },
]

export const INSURANCE_OPTIONS = [
  {
    insurance_id: 'c3294213-a8b5-4cab-87d1-15988787e477',
    clinic_id: 'ed6ea79f-f56b-49a3-af58-34bb3084aca0',
    description: 'Comprehensive coverage',
    insurance_name: 'SafeGuard Insurance',
  },
  {
    insurance_id: 'ef0c268e-9169-4249-9dff-454291251f97',
    clinic_id: 'ed6ea79f-f56b-49a3-af58-34bb3084aca0',
    description: 'Liability insurance',
    insurance_name: 'Shield Insurance',
  },
  {
    insurance_id: '013be7a8-b8f4-44d7-9a4f-742fd6ede809',
    clinic_id: '1372f50e-0704-49c2-b61a-1e4be6d090d1',
    description: 'Collision coverage',
    insurance_name: 'SecureCare Insurance',
  },
  {
    insurance_id: 'ccdb9fa1-18fb-4602-bd1c-7bac1a488e2c',
    clinic_id: '1372f50e-0704-49c2-b61a-1e4be6d090d1',
    description: 'Personal injury protection',
    insurance_name: 'Protective Solutions Insurance',
  },
  {
    insurance_id: 'fba95273-1582-4929-96c5-876c2bad1159',
    clinic_id: 'db08bb8d-915a-46fa-9d1b-ce3eb4cbb6cf',
    description: 'Uninsured motorist coverage',
    insurance_name: 'Guardian Assurance',
  },
]

export const DURATION_OPTIONS = [
  {
    duration: 15,
    text: '15 minutes',
  },
  {
    duration: 30,
    text: '30 minutes',
  },
  {
    duration: 45,
    text: '45 minutes',
  },
  {
    duration: 60,
    text: '1 hour',
  },
  {
    duration: 75,
    text: '1 hour and 15 minutes',
  },
  {
    duration: 90,
    text: '1 hour and 30 minutes',
  },
  {
    duration: 105,
    text: '1 hour and 45 minutes',
  },
  {
    duration: 120,
    text: '2 hours',
  },
  {
    duration: 135,
    text: '2 hours and 15 minutes',
  },
  {
    duration: 150,
    text: '2 hours and 30 minutes',
  },
  {
    duration: 165,
    text: '2 hours and 45 minutes',
  },
  {
    duration: 180,
    text: '3 hours',
  },
]

export const TOOTH_NUMBER = [
  ...Array.from({ length: 16 }, (_, i) => `${i + 1}`),
  ...Array.from({ length: 16 }, (_, i) => `${32 - i}`),
]
/** Single-character procedure surface codes for the tooth picker (no combos). */
export const ATOMIC_TOOTH_SURFACES = [
  'M',
  'D',
  'O',
  'I',
  'B',
  'F',
  'L',
  'P',
] as const

export type AtomicToothSurface = (typeof ATOMIC_TOOTH_SURFACES)[number]

/** Clinical order: anterior MIDFL, posterior MODBL (I/O share the middle slot). */
export const CLINICAL_ATOMIC_SURFACE_ORDER = [
  'M',
  'I',
  'O',
  'D',
  'B',
  'F',
  'L',
  'P',
] as const

export const sortSurfacesByClinicalOrder = (surfaces: string[]): string[] => {
  return [...surfaces].sort((a, b) => {
    const indexA = CLINICAL_ATOMIC_SURFACE_ORDER.indexOf(
      a as (typeof CLINICAL_ATOMIC_SURFACE_ORDER)[number],
    )
    const indexB = CLINICAL_ATOMIC_SURFACE_ORDER.indexOf(
      b as (typeof CLINICAL_ATOMIC_SURFACE_ORDER)[number],
    )
    const orderA = indexA === -1 ? CLINICAL_ATOMIC_SURFACE_ORDER.length : indexA
    const orderB = indexB === -1 ? CLINICAL_ATOMIC_SURFACE_ORDER.length : indexB
    if (orderA !== orderB) {
      return orderA - orderB
    }
    return a.localeCompare(b)
  })
}

const UPPER_TOOTH_NUMBERS: ReadonlySet<number> = new Set(
  Array.from({ length: 16 }, (_, i) => i + 1),
)

const LOWER_TOOTH_NUMBERS: ReadonlySet<number> = new Set(
  Array.from({ length: 16 }, (_, i) => i + 17),
)

/** Incisors and canines (6–11, 22–27): incisal (I), not occlusal (O). */
const INCISOR_CANINE_TOOTH_NUMBERS: ReadonlySet<number> = new Set([
  ...INCISOR_CANINE_TOOTH_IDS,
  ...LOWER_INCISOR_CANINE_TOOTH_IDS,
])

/** Premolars and molars: occlusal (O), not incisal (I). */
const POSTERIOR_TOOTH_NUMBERS: ReadonlySet<number> = new Set([
  ...PREMOLAR_TOOTH_IDS,
  ...LOWER_PREMOLAR_TOOTH_IDS,
  ...MOLAR_TOOTH_IDS,
  ...LOWER_MOLAR_TOOTH_IDS,
])

export const isIncisorOrCanineTooth = (toothNumber: number): boolean =>
  INCISOR_CANINE_TOOTH_NUMBERS.has(toothNumber)

export const isPosteriorTooth = (toothNumber: number): boolean =>
  POSTERIOR_TOOTH_NUMBERS.has(toothNumber)

export const TOOTH_AREA = [
  'M',
  'D',
  'O',
  'I',
  'B',
  'F',
  'L',
  'P',
  'MO',
  'DO',
  'MOD',
  'MOB',
  'MODB',
  'MIFL',
  'BOL',
  'DIL',
  'IF',
  'IL',
  'ML',
  'DL',
  'DF',
  'MF',
  'IFL',
  'MFL',
  'DFL',
  'MDL',
  'MDF',
  'MIDL',
  'MIDF',
  'MIDFL',
]

/** Procedure text → which surface set applies (heuristic when no DB link). */
export type ToothSurfaceArchetype = 'anterior' | 'posterior' | 'unknown'

/**
 * Surfaces appropriate for anterior teeth (incisors, canines): incisal / facial / lingual, etc.
 * Excludes occlusal-only and occlusal composites (O, MO, MOD, …).
 */
const ANTERIOR_TOOTH_SURFACE_CODES: ReadonlySet<string> = new Set([
  'M',
  'D',
  'I',
  'B',
  'F',
  'L',
  'P',
  'IF',
  'IL',
  'ML',
  'DL',
  'DF',
  'MF',
  'IFL',
  'MFL',
  'DFL',
  'MDL',
  'MDF',
  'MIDL',
  'MIDF',
  'MIDFL',
  'MIFL',
  'DIL',
])

/**
 * Surfaces appropriate for posterior teeth (premolars, molars): occlusal / buccal / lingual, etc.
 * Excludes incisal-only codes (I, IF, …).
 */
const POSTERIOR_TOOTH_SURFACE_CODES: ReadonlySet<string> = new Set([
  'M',
  'D',
  'O',
  'B',
  'F',
  'L',
  'P',
  'MO',
  'DO',
  'MOD',
  'MOB',
  'MODB',
  'BOL',
  'ML',
  'DL',
  'DF',
  'MF',
  'MFL',
  'DFL',
  'MDL',
  'MDF',
])

/**
 * Infer anterior vs posterior from free text (e.g. procedure description).
 * If both words appear, returns `unknown` so we do not filter incorrectly.
 */
export function inferToothSurfaceArchetypeFromProcedureText(
  text: string | null | undefined,
): ToothSurfaceArchetype {
  if (text === null || text === undefined || text.trim() === '') {
    return 'unknown'
  }
  const hasAnterior = /\banterior\b/i.test(text)
  const hasPosterior = /\bposterior\b/i.test(text)
  if (hasAnterior && hasPosterior) {
    return 'unknown'
  }
  if (hasAnterior) {
    return 'anterior'
  }
  if (hasPosterior) {
    return 'posterior'
  }
  return 'unknown'
}

/** Preserves `TOOTH_AREA` order; only surfaces allowed for the archetype. */
export function filterToothAreasByArchetype(
  areas: readonly string[],
  archetype: ToothSurfaceArchetype,
): string[] {
  if (archetype === 'unknown') {
    return [...areas]
  }
  const allowed =
    archetype === 'anterior'
      ? ANTERIOR_TOOTH_SURFACE_CODES
      : POSTERIOR_TOOTH_SURFACE_CODES
  return areas.filter((code) => allowed.has(code))
}

/** Universal numbering: incisors and canines (6–11, 22–27). */
const ANTERIOR_TOOTH_NUMBERS: ReadonlySet<number> = INCISOR_CANINE_TOOTH_NUMBERS

export function isToothNumberAllowedForArchetype(
  toothNumber: number,
  archetype: ToothSurfaceArchetype,
): boolean {
  if (archetype === 'unknown') {
    return true
  }
  const isAnterior = ANTERIOR_TOOTH_NUMBERS.has(toothNumber)
  return archetype === 'anterior' ? isAnterior : !isAnterior
}

/** Atomic surfaces valid for a tooth number, then filtered by procedure archetype. */
export function getAtomicSurfacesForTooth(
  toothNumber: number,
  archetype: ToothSurfaceArchetype,
): string[] {
  const surfaces: string[] = ['M', 'D']
  if (isIncisorOrCanineTooth(toothNumber)) {
    surfaces.push('I', 'F')
  } else if (isPosteriorTooth(toothNumber)) {
    surfaces.push('O', 'B')
  } else {
    surfaces.push('O', 'B')
  }
  if (LOWER_TOOTH_NUMBERS.has(toothNumber)) {
    surfaces.push('L')
  }
  if (UPPER_TOOTH_NUMBERS.has(toothNumber)) {
    surfaces.push('P')
  }
  if (archetype === 'unknown') {
    return sortSurfacesByClinicalOrder(surfaces)
  }
  const archetypeAllowed = new Set(
    filterToothAreasByArchetype(ATOMIC_TOOTH_SURFACES, archetype),
  )
  return sortSurfacesByClinicalOrder(
    surfaces.filter((code) => archetypeAllowed.has(code)),
  )
}

export const DAY_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
export const DAY_OF_WEEK_LETTER = ['M', 'T', 'W', 'T', 'F', 'S', 'S']
export const DAY_OF_WEEK_NUMBER = [0, 1, 2, 3, 4, 5, 6]
